module.exports = __webpack_public_path__ + "static/media/AssetsGallery_Thin.9d61686c.svg";